module.exports = __webpack_public_path__ + "69c2b2a125f2e47ba8ee481e9a80ff83.png";